import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9061ff36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navs-container" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "nav-item-title" }
const _hoisted_4 = { class: "nav-item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_carousel = _resolveComponent("a-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_carousel, {
      autoplay: "",
      autoplaySpeed: 5000,
      speed: 1200,
      dotsClass: "slick-dots circle-dots",
      fade: true,
      pauseOnHover: false,
      beforeChange: _ctx.beforeChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemsInfo, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "login-navs",
            key: item.systemTitle
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["nav-title-image", item.imagestyle])
            }, null, 2),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.systemTitle), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.systemFirstcontent), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item-text", 'nav-item-text-' + item.imagestyle])
              }, _toDisplayString(item.systemSecondcontent), 3)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["beforeChange"])
  ]))
}